var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: '100%'}),attrs:{"id":"porizontalpillar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }